import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Images } from '@/assets';
import { useTranslation } from 'react-i18next';

const LanguageButtons = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const changeLang = useCallback(
    (lang: 'en' | 'ko') => () => {
      const hashPath = location.hash.replace('#', '');
      const newPath = hashPath.replace(/^\/(ko|en)/, `/${lang}`);

      i18n.changeLanguage(lang).then(() => {
        navigate(newPath, { replace: true });
      });
    },
    [i18n, navigate]
  );

  return (
    <Actions>
      <LanguageWrapper>
        <CountryImage
          $imgUrl={Images.KoreaLangImg}
          data-selected={i18n.language === 'ko'}
          onClick={changeLang('ko')}
        />
        <CountryImage
          $imgUrl={Images.EnglishLangImg}
          onClick={changeLang('en')}
          data-selected={i18n.language === 'en'}
          data-en={true}
        />
      </LanguageWrapper>
    </Actions>
  );
};

export default LanguageButtons;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const LanguageWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const Divider = styled.div`
  width: 1px;
`;

interface CountryImageProps {
  $imgUrl: string;
}
const CountryImage = styled.button<CountryImageProps>`
  background-image: url(${(props) => props.$imgUrl});
  background-position: center;
  background-size: contain;
  width: 48px;
  height: 48px;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
  &:hover {
    border: 1px solid #5b4be8;
  }
  &[data-selected='true'] {
    border: 1px solid #5b4be8;
  }
  &[data-en='true'] {
    width: 46px;
    height: 46px;
  }
`;
